import PropTypes from 'prop-types';

import {
  ClassNameDefaultProps,
  ClassNamePropTypes,
} from '@/common/proptypes/Base/ClassName.protypes';

export const StocksDetailsDefaultProps = {
  ...ClassNameDefaultProps,
  categoryLabel: null,
  stocks: [],
  unit: null,
};

export const StocksDetailsPropTypes = {
  ...ClassNamePropTypes,
  categoryLabel: PropTypes.string,
  stocks: PropTypes.arrayOf(
    PropTypes.shape({
      batches: PropTypes.arrayOf({
        id: PropTypes.string,
        stock_quantity: PropTypes.number,
      }),
      company: PropTypes.string,
      delay: PropTypes.number,
      quantity: PropTypes.number,
      store_id: PropTypes.number,
      warehouse: PropTypes.string,
    }),
  ),
  unit: PropTypes.string,
};
